import { Vue } from 'vue-property-decorator'

export const invoiceSettlementStatus = () => {
  return {
    PENDING: { key: 50370001, label: Vue.prototype.$gettext('INVOICE_SETTLEMENT_STATUS.50370001') },
    UNDER_REVIEW: { key: 50370002, label: Vue.prototype.$gettext('INVOICE_SETTLEMENT_STATUS.50370002') },
    DENIED: { key: 50370003, label: Vue.prototype.$gettext('INVOICE_SETTLEMENT_STATUS.50370003') },
    APPROVED: { key: 50370004, label: Vue.prototype.$gettext('INVOICE_SETTLEMENT_STATUS.50370004') },
    CANCELED: { key: 50370005, label: Vue.prototype.$gettext('INVOICE_SETTLEMENT_STATUS.50370005') },
    UPDATE: { key: 50370006, label: Vue.prototype.$gettext('INVOICE_SETTLEMENT_STATUS.50370006') }
  }
}
